import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { t } from '../../../../modules/infra/i18n';
import SimpleHeader from '../../headers/simpleHeader';
import BankAccountForm from './bankAccountForm';
import { getShop } from '../../shops/actions';
import { COUNTRY_CODE_BY_CURRENCY } from '../../shops/constants';
import { getShopOrBarberField } from '../../../auth/selectors';
import iosBridge from '../../../iosBridge/iosBridgeService';

class BankAccountAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      country: 'US',
      currency: 'usd',
      errors: null,
      initialValues: {
        type: props.type,
      },
      busy: false,
      // set to true only in case fetch in componentDidMount is not going to happen
      initialized: !this.props.shop,
    };
    this.saveBankAccountBind = (...args) => this.saveBankAccount(...args);
  }

  componentDidMount() {
    if (this.props.shop) {
      this.props.getShop(this.props.shop).then((shop) => {
        this.setState({
          initialized: true,
          currency: shop.currency,
          initialValues: Object.assign({}, this.state.initialValues, {
            email: this.props.email,
            phone: this.props.phone,
            address: {
              city: '',
              line1: '',
              state: '',
              postal_code: '',
              country: COUNTRY_CODE_BY_CURRENCY[shop.currency] || '',
            },
          }),
        });
      }).catch(() => {
        this.setState({ initialized: false });
      });
    }
  }

  saveBankAccount(model, documents) {
    this.setState({ busy: true, errors: null });
    const { saveBankAccount, redirectUrl, uploadBankAccountDocuments } = this.props;

    saveBankAccount(model)
    .then(() => {
      if (!isEmpty(documents)) {
        return uploadBankAccountDocuments(documents);
      }

      return Promise.resolve();
    }).then(() => {
      iosBridge.callHandler('bankAccount://saved');
      this.props.router.push(redirectUrl);
      this.setState({ busy: false });
    }).catch((err) => {
      this.setState({ busy: false, errors: err.message });
    });
  }

  handleCancelClick() {
    iosBridge.callHandler('bankAccount://cancel');
  }

  render() {
    return (
      <div>
        <SimpleHeader heading={t('settings:bank_account_add.title')} />
        <div className="c-wrapper">
          <div className="layout">
            <div className="layout__item u-5/10-extralarge-and-up">
              <div className="c-inner-wrapper u-margin-0">
                <div className="c-label c-label--light u-pb--">{t('settings:bank_account_add.label')}</div>
                <div className="c-paragraph u-mb-">
                  {t('settings:bank_account_add.description')}
                </div>
                <BankAccountForm
                  display-if={this.state.initialized}
                  currency={this.state.currency}
                  formErrors={this.state.errors}
                  saveBankAccount={this.saveBankAccountBind}
                  initialValues={this.state.initialValues}
                  cancelUrl={this.props.redirectUrl}
                  busy={this.state.busy}
                  onCancelClick={this.handleCancelClick}
                />
              </div>
            </div>
            <div className="layout__item u-4/10-extralarge-and-up">
              <div className="c-label c-label--light u-pb--">{t('settings:bank_account_add.when_deposited_title')}</div>
              <div className="c-paragraph u-pb--">
                {t('settings:bank_account_add.when_deposited_description')}
              </div>
              <div className="c-label c-label--light u-mt u-pb--">{t('settings:bank_account_add.closed_account_title')}</div>
              <div className="c-paragraph u-pb--">
                {t('settings:bank_account_add.closed_account_description')}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  shop: state.auth.shop,
  shops: state.auth.user && state.auth.user.shops,
  email: getShopOrBarberField(state, 'email'),
  phone: getShopOrBarberField(state, 'phone'),
});

const mapDispatchToProps = {
  getShop,
};

BankAccountAdd.propTypes = {
  shop: PropTypes.string.isRequired,
  saveBankAccount: PropTypes.func.isRequired,
  uploadBankAccountDocuments: PropTypes.func.isRequired,
  redirectUrl: PropTypes.string.isRequired,
  getShop: PropTypes.func.isRequired,
  email: PropTypes.string,
  phone: PropTypes.string,
  router: PropTypes.objectOf(PropTypes.shape).isRequired,
  type: PropTypes.string.isRequired,
};

BankAccountAdd.defaultProps = {
  email: '',
  phone: '',
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BankAccountAdd));
